const PRAGUE_TZ = "Europe/Prague";

export function formatPragueTimestamp(date: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: PRAGUE_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const obj: Record<string, string> = {};
  for (const p of parts) {
    if (p.type !== "literal") obj[p.type] = p.value;
  }
  const hour = obj.hour === "24" ? "00" : obj.hour;

  const offsetParts = new Intl.DateTimeFormat("en-GB", {
    timeZone: PRAGUE_TZ,
    timeZoneName: "shortOffset",
  }).formatToParts(date);
  const tz = offsetParts.find((p) => p.type === "timeZoneName")?.value ?? "GMT+0";
  const m = tz.match(/GMT([+-])(\d+)(?::(\d+))?/);
  const sign = m?.[1] ?? "+";
  const hh = String(parseInt(m?.[2] ?? "0", 10)).padStart(2, "0");
  const mm = (m?.[3] ?? "00").padStart(2, "0");
  const offset = `${sign}${hh}${mm}`;

  return `${obj.year}-${obj.month}-${obj.day} ${hour}:${obj.minute}:${obj.second}${offset}`;
}
